import React from 'react';
import contactData from '../contact.json';

const Contact = () => {
  const { hero, contact, regional, quality, footer } = contactData;

  return (
    <main className="pt-[60px] min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-[300px] md:h-[400px] overflow-hidden">
        <img 
          src={hero.image} 
          alt="Global Support Network"
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-transparent"></div>
        <div className="absolute inset-0 flex items-center">
          <div className="container mx-auto px-6">
            <p className="text-white/80 text-xs font-bold tracking-[0.2em] mb-2">GET IN TOUCH</p>
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-2">{hero.title.en}</h1>
            <p className="text-xl text-white/90">{hero.title.zh}</p>
          </div>
        </div>
      </section>

      {/* Contact Info Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-8">
            {contact.title.en} <span className="text-gray-600">|</span> {contact.title.zh}
          </h2>
          
          <div className="space-y-8">
            {contact.info.map((item, index) => (
              <div key={index} className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-full bg-gray-100">
                  <span className="material-symbols-outlined text-[#1a5681] text-lg">{item.icon}</span>
                </div>
                <div>
                  <p className="text-xs text-gray-400 font-medium tracking-wider mb-1">{item.label.en}</p>
                  {item.type === 'address' ? (
                    <div className="text-gray-700 text-sm leading-relaxed whitespace-pre-line">
                      {item.value.en}
                    </div>
                  ) : item.type === 'phone' ? (
                    <div>
                      <p className="text-gray-900 font-medium">{item.value}</p>
                      <p className="text-gray-400 text-xs mt-1">{item.note.en}</p>
                    </div>
                  ) : (
                    <p className="text-gray-900 font-medium">{item.value}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Regional Offices */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1">
              <h2 className="text-2xl font-bold text-gray-900 mb-2">{regional.title.en}</h2>
              <p className="text-gray-500 text-sm">{regional.subtitle.en}</p>
            </div>
            <div className="flex-1">
              <img 
                src={regional.image} 
                alt="Global Distribution Network"
                className="w-full max-w-md rounded-lg shadow-lg"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-50 py-8 border-t border-gray-200">
        <div className="container mx-auto px-6">
          <div className="flex flex-col items-center justify-center gap-4">
            <p className="text-gray-400 text-xs text-center">{footer.copyright}</p>
            <p className="text-gray-400 text-xs text-center">
              <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" className="hover:underline">
                {footer.beian}
              </a>
            </p>
          </div>
        </div>
      </footer>
    </main>
  );
};

export default Contact;
